import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { paymentDateFilterConfig } from '../../../configs/payment-date-filter-config';

export const PaymentDateFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Payment Date'
      config={paymentDateFilterConfig}
    />
  );
};
